export default "__VITE_ASSET__BPrqDC0M__"